import { render, staticRenderFns } from "./services-card.vue?vue&type=template&id=44f671ca&scoped=true&lang=pug&"
import script from "./services-card.vue?vue&type=script&lang=js&"
export * from "./services-card.vue?vue&type=script&lang=js&"
import style0 from "./services-card.vue?vue&type=style&index=0&id=44f671ca&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f671ca",
  null
  
)

export default component.exports